import { type ProductizedServiceSkillsTools_productizedService$key } from '#app/__generated__/relay/ProductizedServiceSkillsTools_productizedService.graphql.js';
import { Text } from '#app/components/Primitives/Text.js';
import { TagListMenu } from '#app/components/Tags/TagListMenu/TagListMenu.js';
import { graphql, useFragment } from '@contra/relay';
import { styled } from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

type ProductizedServiceSkillsToolsProps = {
  readonly productizedServiceRef: ProductizedServiceSkillsTools_productizedService$key;
};

export const ProductizedServiceSkillsTools = ({
  productizedServiceRef,
}: ProductizedServiceSkillsToolsProps) => {
  const {
    roles: { edges: rolesEdges },
    tools: { edges: toolsEdges },
  } = useFragment<ProductizedServiceSkillsTools_productizedService$key>(
    graphql`
      fragment ProductizedServiceSkillsTools_productizedService on ProductizedService {
        roles {
          edges {
            node {
              id
              name
            }
          }
        }
        tools {
          edges {
            node {
              id
              logoImage {
                uid
              }
              name
            }
          }
        }
      }
    `,
    productizedServiceRef,
  );
  const roles = rolesEdges.map(({ node: { id, name } }) => ({ id, name }));
  const tools = toolsEdges.map(({ node: { id, logoImage, name } }) => ({
    id,
    logoImage,
    name,
  }));

  return roles.length ? (
    <Container>
      <Text textStyle="subtitleRegular">Skills and tools</Text>
      <TagListMenu<{
        id: string;
        logoImage?: null | { uid: string };
        name: string;
      }>
        ariaLabel="Skills and tools"
        items={[...roles, ...tools]}
        maxRows={3}
        transformItemToTag={(item) => ({
          href: undefined,
          icon: item.logoImage?.uid ? { uid: item.logoImage?.uid } : undefined,
          iconVariant: 'SQUARE_NO_BACKGROUND',
          label: item.name,
          value: item.id,
          variant: 'condensed',
        })}
        variant="condensed"
      />
    </Container>
  ) : null;
};
